var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.36718 0C3.75364 0 0 3.75365 0 8.36719C0 12.981 3.75364 16.7344 8.36718 16.7344C12.981 16.7344 16.7344 12.981 16.7344 8.36719C16.7344 3.75365 12.981 0 8.36718 0ZM8.36718 15.1897C4.6053 15.1897 1.54471 12.1291 1.54471 8.36723C1.54471 4.60534 4.6053 1.54471 8.36718 1.54471C12.1291 1.54471 15.1897 4.60531 15.1897 8.36719C15.1897 12.1291 12.1291 15.1897 8.36718 15.1897Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7737 17.6816L14.3455 13.2534C14.0438 12.9516 13.5551 12.9516 13.2534 13.2534C12.9516 13.5549 12.9516 14.044 13.2534 14.3455L17.6816 18.7737C17.8324 18.9246 18.0299 19 18.2276 19C18.4251 19 18.6228 18.9246 18.7737 18.7737C19.0754 18.4722 19.0754 17.9831 18.7737 17.6816Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.40ad9879.svg";
export { ForwardRef as ReactComponent };